module.exports = __webpack_public_path__ + "img/god-rest-ye.51d7bd6e.jpeg";